import {
    useEffect,
    type FC
} from "react";
import type IFieldDescriptionProps from "./type";
import {
    FIELD_DESCRIPTION_VARIANT,
    getFieldDescriptionColors,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useFieldOutsideWarning,
    useFieldSetContext,
    useFieldContext
} from "../../context";
import {
    getFieldChildrenText
} from "../../util";
import Text from "../../../text";

const FieldDescription: FC<IFieldDescriptionProps> = ({
    customTheme: customThemeProp,
    children,
    style,
    ...props
}) => {
    const setContext = useFieldSetContext();

    const context = useFieldContext();

    useFieldOutsideWarning({
        isInside: !!context || !!setContext,
        parent: "Field> or <Field.Set",
        part: "Description"
    });

    const customTheme = customThemeProp ?? context?.customTheme ?? setContext?.customTheme;

    const {
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const isInSet = !context && Boolean(setContext);

    const currentColors = getFieldDescriptionColors({
        isDisabled: context?.isDisabled ?? false,
        colors
    });

    const {
        description: descriptionDynamicStyle
    } = useStyles({
        isInSet,
        spaces
    });

    const text = getFieldChildrenText(children);

    const registerPart = context?.registerPart;

    const registerSetPart = setContext?.registerPart;

    useEffect(() => {
        if(registerPart) {
            return registerPart("description", text);
        }

        if(registerSetPart) {
            return registerSetPart("description");
        }

        return undefined;
    }, [
        registerSetPart,
        registerPart,
        text
    ]);

    return <Text
        {...props}
        id={context ? context.descriptionID : setContext?.descriptionID}
        variant={FIELD_DESCRIPTION_VARIANT}
        customColor={currentColors.color}
        style={[
            style,
            descriptionDynamicStyle
        ]}
        customTheme={customTheme}
    >
        {children}
    </Text>;
};
export default FieldDescription;
